/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Hiding a quote needs a reason once the quote has a purpose. Ticking \[markUnsellable\] records the operator's verdict that the carrier confirmed the price is wrong: the quote is then hidden and refused by show, select and book until the verdict is reverted. Also the "Mark unsellable" action on an already-hidden quote --- one endpoint, two entry points. \[confirmedWithCarrier\] is recorded on every hide and required for \[markUnsellable\]: hiding a quote often has nothing to do with the carrier, but condemning its price always does.
 * @export
 * @interface MarkQuoteCustomerHiddenBody
 */
export interface MarkQuoteCustomerHiddenBody {
  /**
   *
   * @type {string}
   * @memberof MarkQuoteCustomerHiddenBody
   */
  hiddenQuoteMessage?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof MarkQuoteCustomerHiddenBody
   */
  markUnsellable: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MarkQuoteCustomerHiddenBody
   */
  confirmedWithCarrier: boolean;
}

/**
 * Check if a given object implements the MarkQuoteCustomerHiddenBody interface.
 */
export function instanceOfMarkQuoteCustomerHiddenBody(
  value: object,
): value is MarkQuoteCustomerHiddenBody {
  if (!("markUnsellable" in value) || value["markUnsellable"] === undefined)
    return false;
  if (
    !("confirmedWithCarrier" in value) ||
    value["confirmedWithCarrier"] === undefined
  )
    return false;
  return true;
}

export function MarkQuoteCustomerHiddenBodyFromJSON(
  json: any,
): MarkQuoteCustomerHiddenBody {
  return MarkQuoteCustomerHiddenBodyFromJSONTyped(json, false);
}

export function MarkQuoteCustomerHiddenBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkQuoteCustomerHiddenBody {
  if (json == null) {
    return json;
  }
  return {
    hiddenQuoteMessage:
      json["hiddenQuoteMessage"] == null
        ? undefined
        : json["hiddenQuoteMessage"],
    markUnsellable: json["markUnsellable"],
    confirmedWithCarrier: json["confirmedWithCarrier"],
  };
}

export function MarkQuoteCustomerHiddenBodyToJSON(
  json: any,
): MarkQuoteCustomerHiddenBody {
  return MarkQuoteCustomerHiddenBodyToJSONTyped(json, false);
}

export function MarkQuoteCustomerHiddenBodyToJSONTyped(
  value?: MarkQuoteCustomerHiddenBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    hiddenQuoteMessage: value["hiddenQuoteMessage"],
    markUnsellable: value["markUnsellable"],
    confirmedWithCarrier: value["confirmedWithCarrier"],
  };
}
